function findWithAttr(array, attr, value) {
    for(var i = 0; i < array.length; i += 1) {
        if(array[i][attr] === value) {
            return i;
        }
    }
    return -1;
}


var gamificationMixin = {
    methods: {
      badgeAwarded: function (store,badge) {
          //console.log(store)
          //console.log(store.awards_store.currentSession.badges)
       
            return (findWithAttr(store.awards_tracking.currentSession.badges,"badgeName",badge.badgeName)!=-1)
               
             

      },
      awardPoints: function (awards_tracking,badge) {
        if (awards_tracking.badges.indexOf(badge) == -1){
          awards_tracking.dispatch('awards_tracking/ADD_BADGE_DB',{
               badgeSrc:"aerospace",
               badgeName:'aerospace'

             
             
             })
        }
    },      careerLearnedAndLogged: function (store,world,careerId) {

      console.log(store.prog_tracking.world_info[1][world].pagestate.careersLearned.indexOf(careerId))
        return (store.prog_tracking.world_info[1][world].pagestate.careersLearned.indexOf(careerId)!=-1)
           
    },
       missionAwarded: function (store,world,mission) {
        //console.log(store.awards_tracking.currentSession.completedMissions)
     console.log(store.awards_tracking.currentSession.completedMissions[world],"missionName",mission.missionName)
     console.log(findWithAttr(store.awards_tracking.currentSession.completedMissions[world],"missionName",mission.missionName)!=-1)
          return (findWithAttr(store.awards_tracking.currentSession.completedMissions[world],"missionName",mission.missionName)!=-1)
             
      },
     achieveAwarded: function (store,world,achievement) {
    
        //console.log(store.awards_tracking.currentSession.completedAchievements)
     
        return (findWithAttr(store.awards_tracking.currentSession.completedAchievements[world],"achieveName",achievement.achievementName)!=-1)
           
  }
    }
  };
  export default gamificationMixin
